// extracted by mini-css-extract-plugin
module.exports = {"main-page":"SingleTestPage_main-page__3zcwl"};